import { NavLink, Outlet, useMatch } from "react-router-dom";
import MetaData from "../../../components/MetaData";

const SubCategoryMetaData = () => {

  const isAddPage = useMatch(
    "/MetadataManagement/SubCategoryMetaData/AddMetaSubCategory"
  );

  const isEditPage = useMatch(
    "/MetadataManagement/SubCategoryMetaData/EditSubCatMetaData/:id"
  );

  const showList = !isAddPage && !isEditPage;

  return (
    <>
      {/* Add Button */}
      {showList && (
        <div className="d-flex justify-content-end mb-3">
          <NavLink to="AddMetaSubCategory" className="Button">
            <i className="fa fa-plus" /> Add Meta Data SUB
          </NavLink>
        </div>
      )}

      {/* Table */}
      {showList && <MetaData type="SUBCATEGORY" />}

      {/* Add / Edit Forms */}
      <Outlet />
    </>
  );
};

export default SubCategoryMetaData;
